import { render } from "./test.vue?vue&type=template&id=1e958a2b&ts=true"
import script from "./test.vue?vue&type=script&lang=ts"
export * from "./test.vue?vue&type=script&lang=ts"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__